"use client";

import { Button } from "@/components/ui/button";
import { useCart } from "@/context";
import { CartItemType } from "@/lib/schema";

export function BuySection({ item }: { item: CartItemType }) {
  const { addToCart, items } = useCart();
  const currentItem = items.find((c) => c.productId === item.productId);

  if (!currentItem?.adding && !!currentItem)
    return (
      <Button variant="default" size="lg" className="rounded-xl" disabled>
        Сагсалсан
      </Button>
    );
  return (
    <Button
      variant="default"
      size="lg"
      className="rounded-xl"
      disabled={currentItem?.adding}
      onClick={() => addToCart(item)}
    >
      Худалдаж авах
    </Button>
  );
}
